import SearchFilterSection from '@components/searchFilterSection/SearchFilterSection'
import { AssetsModule } from '@core/modules/digital-footprint/assets'
import { unifiedDomainsFilterModule } from '@core/modules/digital-footprint/assets/domains.filters'
import { DOMAIN_ASSET_TYPES } from '@core/modules/digital-footprint/assets/constants'
import { FC, useMemo } from 'react'
import { useUnifiedFilter } from '@core/hooks/useUnifiedFilter'

const DomainsHeader: FC = () => {
    const { data: allAssets } = AssetsModule.useStore()

    const domainAssets = useMemo(
        () => allAssets.filter((a) => DOMAIN_ASSET_TYPES.includes(a.asset_type)),
        [allAssets]
    )

    const {
        search,
        filterConfig,
        data: filteredAssets,
        handleFilterChange,
        handleSearchChange,
        handleFilterReset,
        getFilterOptions,
        activeFilters,
    } = useUnifiedFilter({
        filterModule: unifiedDomainsFilterModule,
        data: domainAssets,
    })

    return (
        <SearchFilterSection
            allItems={domainAssets}
            filteredItems={filteredAssets}
            onSearchChange={handleSearchChange}
            onFilterChange={handleFilterChange}
            getFilterOptions={getFilterOptions}
            filterConfig={filterConfig}
            searchValue={search}
            activeFilters={activeFilters}
            searchPlaceholder="Search domains..."
            itemLabel="domains"
            onFilterReset={handleFilterReset}
        />
    )
}

export default DomainsHeader
